export const scrollToWordByClassName = (className: string): void => {
  document.querySelector('.' + className)?.scrollIntoView({
    behavior: 'smooth',
    block: 'center'
    // inline: 'center'
  })
}
